import React from "react";
import { MatchScore } from "../../types";

export function getScore(playerId: string, scores: MatchScore[]): MatchScore {
	if (!scores || !playerId) {
		return { score: [], uuid: playerId };
	}

	for (let score of scores) {
		if (score.uuid === playerId) {
			return score;
		}
	}

	return { score: [], uuid: playerId };
}

export function getMatchStatus(winnerId: string, myId: string) {
	{
		winnerId === null ? <div>PLAYED</div> : winnerId === myId ? <div>WON</div> : <div>LOST</div>;
	}
}
